<template>
  <v-container id="page-role-list">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col>
        <div style="width: 250px; display: inline-block;">
          <v-text-field
              v-model="searchKeyword"
              label="권한명 검색"
              prepend-icon="search"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn v-if="this.$store.state.userInfo.role == 'SA'" color="blue" class="ml-1" outlined iconName="add" @click="openCreateDialog">권한 추가</c-btn>
      </v-col>
    </v-row>

    <c-table
      :headers="roleTableHeaders"
      itemKey="id"
      :items="searchByKeyword"
    >
      <template #categoryName="{ item }" >
        {{majorList(item.categoryName)}}
      </template>
      <template #created="{ item }">
        {{$func.dateToString(item.created)}}
      </template>
      <template #detail="{ item }">
        <c-btn icon iconName="search" @click="onMoveDetail(item.id)"/>
      </template>
    </c-table>

    <RoleCUDialog
      :open.sync="openFlag"
      :role-data-id="detailDataId"
      @reqAddRole="reqAddRole"
      @reqGetRoleList="reqGetRoleList"
    />



  </v-container>
</template>
<script>
  import RoleCUDialog from './RoleCRDialog'

  export default {
    components: {
      RoleCUDialog
    },
    data: () => ({
      roleTableHeaders: [
        {
          text: '권한명',
          value: 'name',
          align: 'center',
          sortable: true,
        },
        {
          text: '내역',
          value: 'categoryName',
          align: 'center',
          sortable: true,
        },
        {
          text: '등록일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
        {
          text: '상세보기',
          value: 'detail',
          align: 'center',
          sortable: false,
        },
      ],

      searchKeyword: '',
      roleList: [],
      openFlag: false,

      roleInfo: null,

      detailDataId: '',
    }),
    activated() {
      this.reqGetRoleList();
    },
    watch: {
    },
    computed: {
      searchByKeyword() {
        return this.roleList.filter(item => item.name.indexOf(this.searchKeyword) > -1);
      }
    },
    methods: {
      async reqGetRoleList() {
        try {
          const res = await this.$api.getAdminRoleByCenterId();
          this.roleList = res.data;
          console.log('res/ reqGetRoleList : ', res.data);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetRoleList'});
        }
      },
      majorList(data){
        let len = data.split(',').length;
        if(len < 4) return data;
        else {
          let str = [];
          for(let idx in data.split(',')) {
            if(idx < 2) str.push(data.split(',')[idx]);
            else break;
          }
          return str.join() + '...';
        }
      },
      onMoveDetail(id) {
        this.detailDataId = id;
        if (this.detailDataId) this.openFlag = true;
      },
      async reqAddRole(data) {
        try {
          const res = await this.$api.postAdminRole(data);

          await this.reqGetRoleList();
          this.openFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddRole'});
        }
      },
      openCreateDialog() {
        this.detailDataId = '';
        this.openFlag = true;
      }
    },
  }
</script>

<style>

</style>